import React from "react";
import "./ProfileCard.css"
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import ProfileCard from "../../Components/ProfileCard/ProfileCard";

const API_BASE = "https://api.knowconnections.com";

const ProfileCardPage = () => {
  const { id } = useParams();

  const ogImageUrl = id ? `${API_BASE}/api/v1/card/og-image/${id}` : null;

  return (
    <>
      <Helmet>
        <title>Profile - KC (Know Connections) | Digital Card Solutions</title>
        <meta
          name="description"
          content="View this digital card on KnowConnections — 1000+ unique card designs."
        />
        <link rel="icon" type="image/png" href="/KC.ico" />
        {ogImageUrl && <meta property="og:image"       content={ogImageUrl} />}
        {ogImageUrl && <meta property="og:image:width"  content="430" />}
        {ogImageUrl && <meta property="og:image:height" content="225" />}
        {ogImageUrl && <meta property="og:type"         content="profile" />}
        {ogImageUrl && <meta property="og:site_name"    content="KnowConnections" />}
        {ogImageUrl && <meta name="twitter:card"        content="summary_large_image" />}
        {ogImageUrl && <meta name="twitter:image"       content={ogImageUrl} />}
      </Helmet>

      <div className="main-wrapper">
        <ProfileCard/>
      </div>
    </>
  );
};

export default ProfileCardPage;
